import { FC, ReactElement } from 'react'

import { Page } from '@/components'
import { ConnectedMessageDetail } from '@/connectors'

export const MessageDetailPage: FC = (): ReactElement => (
    <Page className="message-detail-page">
        <ConnectedMessageDetail />
    </Page>
)
